"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var warning_1 = require("../util/warning");
var warned = {};
function deprecated(validator, reason) {
    return function validate(props, propName, componentName, location, propFullName) {
        var args = [];
        for (var _i = 5; _i < arguments.length; _i++) {
            args[_i - 5] = arguments[_i];
        }
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] != null) {
            var messageKey = componentName + "." + propName;
            warning_1.default(warned[messageKey], "The " + location + " `" + propFullNameSafe + "` of " +
                ("`" + componentNameSafe + "` is deprecated. " + reason + "."));
            warned[messageKey] = true;
        }
        return validator.apply(void 0, [props, propName, componentName, location, propFullName].concat(args));
    };
}
exports.deprecated = deprecated;
(function (deprecated) {
    function _resetWarned() {
        warned = {};
    }
    deprecated._resetWarned = _resetWarned;
})(deprecated = exports.deprecated || (exports.deprecated = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/react-prop-types/deprecated.js
// module id = 472
// module chunks = 0 1 2 3 4 5 6